import { useZunelo } from '../context/ZuneloContext';
import type { AttentionItemWorkContextMembership } from '../domain/radarThreads';

/**
 * Resolves the Radar work context for an attention card id.
 *
 * Looks up the shared `workContextIndex` computed once in `ZuneloProvider`
 * instead of re-running the full clustering pass per mounted card — with N
 * cards each building their own index, this used to be O(N^2).
 */
export function useWorkContextMembership(
  itemId: string,
): AttentionItemWorkContextMembership | undefined {
  const { workContextIndex } = useZunelo();
  return workContextIndex.get(itemId);
}
